import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiClient,
  AttachmentGroupInfo,
  AttachmentInfo,
  AzureBlobUploadResult,
  FileParameter,
  UpdateAttachmentRequestData,
} from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  private readonly sdk: ApiClient = inject(ApiClient);

  getAttachmentsByOpportunityId(opportunityId: string): Observable<AttachmentInfo[]> {
    return this.sdk.getAttachments(opportunityId);
  }

  getAttachmentGroups(): Observable<AttachmentGroupInfo[]> {
    return this.sdk.getAttachmentGroupsWeb();
  }

  uploadAttachment(
    opportunityId: string,
    appointmentId: string,
    file: FileParameter,
    quoteId: string | null,
    attachmentGroupId: string | null,
    description: string | null
  ): Observable<AzureBlobUploadResult[]> {
    console.log('ATTACHMENT SERVICE', quoteId);
    return this.sdk.uploadAttachment(
      opportunityId,
      appointmentId,
      file,
      quoteId!,
      attachmentGroupId!,
      description!
    );
  }

  deleteAttachment(attachmentId: string): Observable<void> {
    return this.sdk.deleteAttachment(attachmentId);
  }

  updateAttachment(attachmentId: string, attachmentGroupId: string | null, description: string | null): Observable<void> {
    const request = {
      attachmentGroupId: attachmentGroupId ?? undefined,
      description: description ?? undefined
    } as UpdateAttachmentRequestData;

    return this.sdk.updateAttachmentInSalesApp(attachmentId, request);
  }
}
